import { Capacitor } from "@capacitor/core";

const PROD_API = "https://api.complymax.co.in";
const DEV_API = "http://localhost:8000";

const isLocalHost = (host) =>
  host === "localhost" || host === "127.0.0.1" || host === "::1";

export const getBackendUrl = () => {
  const envUrl = (process.env.REACT_APP_BACKEND_URL || "").trim();
  const host = window.location.hostname;
  const runningLocal = isLocalHost(host);
  const runningNative = Capacitor.isNativePlatform();

  if (envUrl) {
    const envLooksLocal =
      envUrl.includes("localhost") || envUrl.includes("127.0.0.1");

    // `localhost` in an Android WebView is the emulator/device, not the
    // development computer. Use the deployed API by default; a local Android
    // build can opt in with REACT_APP_ANDROID_BACKEND_URL (10.0.2.2 on the
    // standard Android emulator, or the computer's LAN address on a device).
    if (runningNative && envLooksLocal) {
      return (process.env.REACT_APP_ANDROID_BACKEND_URL || PROD_API).replace(/\/+$/, "");
    }

    // In production browser, ignore accidental localhost env and use production API.
    if (!runningLocal && envLooksLocal) return PROD_API;
    return envUrl.replace(/\/+$/, "");
  }

  return runningNative ? PROD_API : runningLocal ? DEV_API : PROD_API;
};

